var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgNoInternetConnection = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 250 200"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F9FAFB",
  fillRule: "evenodd",
  d: "M63 134h91q.774-.002 1.5-.161.726.16 1.5.161h52a7 7 0 1 0 0-14h-6a7 7 0 1 1 0-14h19a7 7 0 1 0 0-14h-22a7 7 0 1 0 0-14h-64a7 7 0 1 0 0-14H79a7 7 0 1 0 0 14H39a7 7 0 1 0 0 14h25a7 7 0 1 1 0 14H24a7 7 0 1 0 0 14h39a7 7 0 1 0 0 14m163 0a7 7 0 1 0 0-14 7 7 0 0 0 0 14",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#9CA3AF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M101 142.852v-8.176m7.777 14.5V132zm0 7v-2.221zM132.777 146.176v17.176m0 5.824v4.221M124 141.5v8.176M132.777 132v8.176M148 132v8.176m8.777-3.5v17.176zm0 23v4.221z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M92 124c-12.15 0-22-9.626-22-21.5S79.85 81 92 81q.776 0 1.537.052A34 34 0 0 1 93 75c0-18.778 15.222-34 34-34 14.991 0 27.716 9.702 32.239 23.17A31 31 0 0 1 162.5 64c16.845 0 30.5 13.432 30.5 30 0 15.741-12.325 28.727-28 29.978V124h-56.492m-4.512 0h-6.965z",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#374151",
  d: "M92 125.25a1.25 1.25 0 0 0 0-2.5zm1.537-44.198-.084 1.247 1.597.108-.283-1.576zm65.702-16.883-1.185.398.318.95.997-.104zM165 123.979l-.099-1.246-1.151.092v1.154zm0 .022v1.25h1.25V124zm-56.492-1.25a1.25 1.25 0 1 0 0 2.5zm-4.512 2.5a1.25 1.25 0 0 0 0-2.5zm-6.965-2.5a1.25 1.25 0 0 0 0 2.5zm-5.031 0c-11.487 0-20.75-9.093-20.75-20.25h-2.5c0 12.591 10.437 22.75 23.25 22.75zM71.25 102.5c0-11.157 9.263-20.25 20.75-20.25v-2.5c-12.813 0-23.25 10.159-23.25 22.75zM92 82.25q.733 0 1.453.049l.168-2.495A24 24 0 0 0 92 79.75zm2.767-1.42A33 33 0 0 1 94.25 75h-2.5c0 2.14.19 4.236.557 6.273zM94.25 75c0-18.087 14.663-32.75 32.75-32.75v-2.5c-19.468 0-35.25 15.782-35.25 35.25zM127 42.25c14.438 0 26.697 9.344 31.054 22.317l2.37-.795C155.735 49.81 142.544 39.75 127 39.75zm32.369 23.163a30 30 0 0 1 3.131-.163v-2.5q-1.719.001-3.391.176zm3.131-.163c16.174 0 29.25 12.891 29.25 28.75h2.5c0-17.278-14.235-31.25-31.75-31.25zM191.75 94c0 15.07-11.805 27.532-26.849 28.732l.198 2.492c16.307-1.301 29.151-14.813 29.151-31.224zm-28 29.978V124h2.5v-.022zm1.25-1.228h-56.492v2.5H165zm-61.004 0h-6.965v2.5h6.965z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#F9FAFB",
  fillRule: "evenodd",
  d: "M116.612 48.343c0 32.223 29.021 58.775 66.388 62.36-4.683 5.758-11.914 9.664-20.153 10.278V121H95.743C87.601 121 74 117.57 74 102.548c0-15.021 10.574-18.451 21.743-18.451q.713 0 1.413.044c-.324-1.685-.381-3.423-.494-5.194-.758-11.963 4.461-27.04 19.968-31.947q-.018.67-.018 1.343",
  clipRule: "evenodd"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#9CA3AF",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "M137 53a19.04 19.04 0 0 1 13.44 13.293"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#9CA3AF",
  strokeWidth: 2,
  d: "M158 34a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#9CA3AF",
  d: "M189 50a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  stroke: "#9CA3AF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "m165.757 41.757 8.359 8.359m.127-8.359-8.359 8.359zM71.404 59.596l6 6m0-6-6 6z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#9CA3AF",
  d: "M85 53a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
})));
export default SvgNoInternetConnection;